import { SVGProps } from 'react'

export const DotIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="8"
    viewBox="0 0 9 8"
    fill="none"
    {...props}
  >
    <circle cx="4.5" cy="4" r="4" fill={props.fill} />
  </svg>
)
